import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateSkills = () => {
  const queryClient = useQueryClient();
   const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ input }) => {
      const result = await restClient({
        url: `${prefix}/cms/skills`,
        method: 'POST',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch skills list and single skill after successful update
      queryClient.invalidateQueries(['skills']);
    }
  });
};